






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticDetailNor } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticDetailNor
  },
  mixins: [RenderMenuMixin]
})

/**
 * 总览-项目明细
 */
export default class StatisticStaffComicDetail extends Vue {

  private comicId: number = 0; // 漫画id

  private created() {
    this.comicId = parseInt(this.$route.params.id, 0);
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId} isNor={true}></acgn-statics-menu>
    );
  }
}
